export const PERSONAL_ROUTE_NAME = 'personal';
export const SOCIAL_ROUTE_NAME = 'social';
export const CALENDARS_ROUTE_NAME = 'calendars';
export const MAGIC_BUTTON_ROUTE_NAME = 'magic';
export const INTEGRATIONS_ROUTE_NAME = 'integrations';
